/* Dr.Kalla storefront chat widget.
   Renders the floating launcher + chat panel, streams answers from the app-proxy
   endpoint (/apps/drkalla-profi/chat) over SSE, shows product cards and handles
   add-to-cart. Config comes from window.DKChatConfig (set in the Liquid snippet). */
(function () {
  "use strict";

  var cfg = window.DKChatConfig || {};
  var ENDPOINT = cfg.endpoint || "/apps/drkalla-profi/chat";
  var NEWSLETTER_URL = cfg.newsletterUrl || "/apps/drkalla-profi/newsletter";
  var CART_ADD = cfg.cartAddUrl || "/cart/add.js";
  var CART_URL = cfg.cartUrl || "/cart";
  var STORAGE_KEY = "dkChatHistory.v1";
  var MAX_MSG_LEN = 4000;
  // Conversion config (see drkalla-chat-widget.liquid).
  var FREE_SHIP = Number(cfg.freeShipThreshold) || 0; // in cents; 0 disables the bar
  var CURRENCY = cfg.currencySymbol || "€";
  var WELCOME_PCT = Number(cfg.welcomePercent) || 10;
  var SUGGESTIONS = cfg.suggestions || [
    "Welches Shampoo bei coloriertem Haar?",
    "Habt ihr Blondierung?",
    "Wie sind Versand & Lieferzeit?",
  ];

  var root, body, input, sendBtn, launcher, panel;
  var shipWrap, shipTxt, shipFill;
  var messages = loadHistory();
  var streaming = false;
  var currentBubble = null;
  var statusEl = null;
  var greeted = false;
  var currentAbort = null;

  // --- utils ---------------------------------------------------------------
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  // Escape first (XSS-safe), then apply a small markdown subset: **bold**,
  // [text](url) links, "- "/"* " bullet lists, and newlines.
  function renderText(s) {
    var esc = escapeHtml(stripMarkers(s))
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g,
        '<a href="$2" target="_top" rel="noopener">$1</a>'
      );
    var lines = esc.split("\n");
    var parts = [];
    var textRun = [];
    var listRun = [];
    function flushText() {
      if (textRun.length) {
        parts.push(textRun.join("<br>"));
        textRun = [];
      }
    }
    function flushList() {
      if (listRun.length) {
        parts.push('<ul class="dk-md-list"><li>' + listRun.join("</li><li>") + "</li></ul>");
        listRun = [];
      }
    }
    for (var i = 0; i < lines.length; i++) {
      var m = lines[i].match(/^\s*[-*]\s+(.*)$/);
      if (m) {
        flushText();
        listRun.push(m[1]);
      } else {
        flushList();
        textRun.push(lines[i]);
      }
    }
    flushText();
    flushList();
    return parts.join("");
  }
  function scrollDown() {
    if (body) body.scrollTop = body.scrollHeight;
  }
  function isMobile() {
    return window.matchMedia("(max-width: 600px)").matches;
  }
  function formatMoney(cents) {
    var v = (Number(cents) || 0) / 100;
    try {
      return (
        v.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        " " +
        CURRENCY
      );
    } catch (e) {
      return v.toFixed(2) + " " + CURRENCY;
    }
  }
  function loadHistory() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.slice(-12) : [];
    } catch (e) {
      return [];
    }
  }
  function saveHistory() {
    try {
      var trimmed = messages.slice(-12).map(function (m) {
        return { role: m.role, content: String(m.content || "").slice(0, MAX_MSG_LEN) };
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (e) {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e2) {
        /* ignore */
      }
    }
  }

  // Once-per-session gate for the proactive welcome-voucher offer (anti-spam).
  var OFFER_KEY = "dkOfferShown.v1";
  function offerShown() {
    try {
      return sessionStorage.getItem(OFFER_KEY) === "1";
    } catch (e) {
      return false;
    }
  }
  function markOfferShown() {
    try {
      sessionStorage.setItem(OFFER_KEY, "1");
    } catch (e) {}
  }
  // Eligible = guest, a welcome offer exists, and we haven't offered yet.
  function voucherEligible() {
    return !cfg.customerLoggedIn && WELCOME_PCT > 0 && !offerShown();
  }
  // Strip the agent's control markers from any displayed/stored text.
  function stripMarkers(s) {
    return String(s == null ? "" : s).replace(
      /\[\[(?:GUTSCHEIN|WHATSAPP)\]\]/g,
      ""
    );
  }

  // --- DOM build -----------------------------------------------------------
  function build() {
    root = document.getElementById("dk-chat-root");
    if (!root) {
      root = el("div");
      root.id = "dk-chat-root";
      document.body.appendChild(root);
    }

    launcher = el("button", "dk-chat-launcher");
    launcher.setAttribute("aria-label", "Beratung öffnen");
    launcher.setAttribute("aria-expanded", "false");
    launcher.innerHTML =
      '<svg class="dk-ic dk-ic-chat" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 6.5h15v9h-9l-4 3.5z"></path><path d="M8.5 10.5h7M8.5 13h4.5"></path></svg>' +
      '<svg class="dk-ic dk-ic-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"></path></svg>';

    panel = el("div", "dk-chat-panel");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute("aria-label", "Dr.Kalla Berater");
    // Brand the header with the shop logo when available; else a "DK" monogram.
    var headerBrand = cfg.logo
      ? '<div class="dk-chat-header__meta">' +
        '<img class="dk-chat-header__logo" src="' +
        escapeHtml(cfg.logo) +
        '" alt="Dr.Kalla">' +
        '<div class="dk-chat-header__sub">Beratung &amp; Empfehlungen</div>' +
        "</div>"
      : '<div class="dk-chat-header__avatar">DK</div>' +
        '<div class="dk-chat-header__meta">' +
        '<div class="dk-chat-header__title">Dr.Kalla</div>' +
        '<div class="dk-chat-header__sub">Beratung &amp; Empfehlungen</div>' +
        "</div>";
    panel.innerHTML =
      '<div class="dk-chat-header">' +
      headerBrand +
      '<button class="dk-chat-header__close" aria-label="Schließen">&times;</button>' +
      "</div>" +
      '<div class="dk-ship" id="dk-ship" hidden>' +
      '<div class="dk-ship__txt" id="dk-ship-txt"></div>' +
      '<div class="dk-ship__bar"><span class="dk-ship__fill" id="dk-ship-fill"></span></div>' +
      "</div>" +
      '<div class="dk-chat-body" id="dk-chat-body"></div>' +
      '<div class="dk-chat-foot">' +
      '<form class="dk-chat-form" id="dk-chat-form">' +
      '<textarea class="dk-chat-input" id="dk-chat-input" rows="1" placeholder="Ihre Frage …" autocomplete="off"></textarea>' +
      '<button type="submit" class="dk-chat-send" id="dk-chat-send" aria-label="Senden">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11l18-8-8 18-2-7-8-3z"></path></svg>' +
      "</button>" +
      "</form>" +
      '<div class="dk-chat-foot__legal">Dr.Kalla · Beratung ohne Gewähr · <a href="/pages/contact">Kontakt</a></div>' +
      "</div>";

    root.appendChild(launcher);
    root.appendChild(panel);

    body = panel.querySelector("#dk-chat-body");
    input = panel.querySelector("#dk-chat-input");
    sendBtn = panel.querySelector("#dk-chat-send");
    shipWrap = panel.querySelector("#dk-ship");
    shipTxt = panel.querySelector("#dk-ship-txt");
    shipFill = panel.querySelector("#dk-ship-fill");

    // Keep the free-shipping bar + header badge in sync with any cart change.
    document.addEventListener("dk:cart-updated", syncCart);

    launcher.addEventListener("click", onLauncherClick);
    panel.querySelector(".dk-chat-header__close").addEventListener("click", close);
    panel.querySelector("#dk-chat-form").addEventListener("submit", onSubmit);
    input.addEventListener("input", autoGrow);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSubmit(e);
      }
    });

    // a11y: Escape closes; Tab is trapped within the open dialog.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("dk-open")) close();
    });
    panel.addEventListener("keydown", trapTab);

    // Keep the mobile collapsed-tab state in sync when the viewport crosses 600px.
    var mq = window.matchMedia("(max-width: 600px)");
    var onBreak = function (e) {
      if (root.classList.contains("dk-open")) return;
      if (e.matches) root.classList.add("dk-mini");
      else root.classList.remove("dk-mini");
    };
    if (mq.addEventListener) mq.addEventListener("change", onBreak);
    else if (mq.addListener) mq.addListener(onBreak);

    if (isMobile()) root.classList.add("dk-mini");
  }

  function trapTab(e) {
    if (e.key !== "Tab") return;
    var nodes = panel.querySelectorAll(
      'button, a[href], textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    var list = Array.prototype.filter.call(nodes, function (n) {
      return !n.disabled && n.offsetParent !== null;
    });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function autoGrow() {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 96) + "px";
  }

  // --- open/close ----------------------------------------------------------
  // On mobile the launcher starts as a slim edge-tab: first tap expands it to
  // the full circle, the next tap opens the chat.
  function onLauncherClick() {
    if (isMobile() && root.classList.contains("dk-mini")) {
      root.classList.remove("dk-mini");
      return;
    }
    toggle();
  }
  function toggle() {
    root.classList.contains("dk-open") ? close() : open();
  }
  function open() {
    root.classList.add("dk-open");
    launcher.setAttribute("aria-expanded", "true");
    syncCart();
    if (!greeted) {
      greeted = true;
      restoreOrGreet();
    }
    setTimeout(function () {
      input && input.focus();
      scrollDown();
    }, 60);
  }
  function close() {
    root.classList.remove("dk-open");
    launcher.setAttribute("aria-expanded", "false");
    // Abort an in-flight response so it doesn't keep streaming into a closed panel.
    if (currentAbort) {
      try {
        currentAbort.abort();
      } catch (e) {
        /* ignore */
      }
    }
    if (isMobile()) root.classList.add("dk-mini");
    // Return focus to the launcher for keyboard users.
    if (launcher) launcher.focus();
  }

  function restoreOrGreet() {
    if (messages.length > 0) {
      messages.forEach(function (m) {
        addBubble(m.role === "assistant" ? "bot" : "user", m.content);
      });
      scrollDown();
      return;
    }
    var name = cfg.customerName ? " " + cfg.customerName : "";
    addBubble(
      "bot",
      "Willkommen bei Dr.Kalla" +
        name +
        ". Gern helfe ich Ihnen, das passende Produkt zu finden, und beantworte Fragen zu Versand, Rückgabe und mehr. Womit darf ich helfen?"
    );
    var chips = SUGGESTIONS.map(function (s) {
      return { label: s, value: s };
    });
    // Welcome-voucher entry point — only for guests (logged-in customers can't
    // redeem the first-order code, mirroring the homepage popup logic).
    if (!cfg.customerLoggedIn) {
      chips.unshift({
        label: WELCOME_PCT + " % auf Ihre erste Bestellung",
        value: "__dk_newsletter__",
        cls: "dk-chip--gift",
      });
    }
    if (cfg.whatsapp) {
      chips.push({
        label: "Per WhatsApp schreiben",
        value: "__dk_whatsapp__",
        cls: "dk-chip--wa",
      });
    }
    renderChips(chips);
  }

  // --- conversion: free-shipping bar --------------------------------------
  function setShipPct(p) {
    if (shipFill) shipFill.style.width = Math.max(0, Math.min(100, p)) + "%";
  }
  function renderShipBar(totalCents) {
    if (!shipWrap || !FREE_SHIP) return;
    var remain = FREE_SHIP - totalCents;
    shipWrap.classList.remove("dk-ship--done");
    if (totalCents <= 0) {
      shipTxt.innerHTML =
        "Versandkostenfrei ab <strong>" + formatMoney(FREE_SHIP) + "</strong>";
      setShipPct(4);
    } else if (remain <= 0) {
      shipTxt.innerHTML =
        "<strong>Versandkostenfrei</strong> — Ihr Vorteil ist aktiv.";
      shipWrap.classList.add("dk-ship--done");
      setShipPct(100);
    } else {
      shipTxt.innerHTML =
        "Noch <strong>" +
        formatMoney(remain) +
        "</strong> bis zur versandkostenfreien Lieferung";
      setShipPct(Math.round((totalCents / FREE_SHIP) * 100));
    }
    shipWrap.removeAttribute("hidden");
  }
  // One read of /cart.js drives both the free-shipping bar and the header badge.
  function syncCart() {
    fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (c) {
        if (!c) return;
        renderShipBar(c.total_price || 0);
        updateCartBubble(c.item_count || 0);
      })
      .catch(function () {
        /* ignore — UI just stays as-is */
      });
  }

  // --- conversion: WhatsApp handoff ---------------------------------------
  function openWhatsApp() {
    if (!cfg.whatsapp) return;
    var num = String(cfg.whatsapp).replace(/[^0-9]/g, "");
    if (!num) return;
    var text = encodeURIComponent(
      cfg.whatsappText || "Hallo Dr.Kalla, ich habe eine Frage zu …"
    );
    window.open("https://wa.me/" + num + "?text=" + text, "_blank", "noopener");
  }

  // --- conversion: newsletter / welcome voucher ---------------------------
  // CTA bubble shown once when the agent decides to offer (marker [[GUTSCHEIN]]).
  function renderVoucherCta() {
    var row = el("div", "dk-chips");
    var chip = el(
      "button",
      "dk-chip dk-chip--gift",
      WELCOME_PCT + " % auf Ihre erste Bestellung sichern"
    );
    chip.addEventListener("click", function () {
      row.remove();
      openNewsletter();
    });
    row.appendChild(chip);
    body.appendChild(row);
    scrollDown();
  }
  function openNewsletter() {
    // Any path into the form counts as "offered" — the agent won't push again.
    markOfferShown();
    var card = el("div", "dk-news");
    card.innerHTML =
      '<div class="dk-news__title">' +
      WELCOME_PCT +
      " % auf Ihre erste Bestellung</div>" +
      '<div class="dk-news__sub">Tragen Sie sich in unseren Newsletter ein — Sie erhalten Ihren persönlichen Gutschein per E-Mail. Abmeldung jederzeit möglich.</div>' +
      '<form class="dk-news__form" novalidate>' +
      '<input type="email" class="dk-news__email" placeholder="Ihre E-Mail-Adresse" autocomplete="email" required>' +
      '<label class="dk-news__consent"><input type="checkbox" class="dk-news__ok" required> Ja, ich möchte den Gutschein und Angebote von Dr.Kalla per E-Mail erhalten.</label>' +
      '<button type="submit" class="dk-news__btn">' +
      WELCOME_PCT +
      "%-Gutschein sichern</button>" +
      '<div class="dk-news__err" hidden></div>' +
      "</form>";
    body.appendChild(card);
    scrollDown();

    var form = card.querySelector(".dk-news__form");
    var emailEl = card.querySelector(".dk-news__email");
    var okEl = card.querySelector(".dk-news__ok");
    var btn = card.querySelector(".dk-news__btn");
    var errEl = card.querySelector(".dk-news__err");
    function showErr(m) {
      errEl.textContent = m;
      errEl.removeAttribute("hidden");
    }
    setTimeout(function () {
      try {
        emailEl.focus();
      } catch (e) {}
    }, 40);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      errEl.setAttribute("hidden", "");
      var email = (emailEl.value || "").trim();
      if (!email || email.indexOf("@") < 1 || email.indexOf(".") < 0) {
        showErr("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
        return;
      }
      if (!okEl.checked) {
        showErr("Bitte bestätigen Sie kurz die Einwilligung.");
        return;
      }
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = "…";
      var fd = new FormData();
      fd.append("email", email);
      fd.append("offer", "welcome");
      fd.append("source", "chat");
      fetch(NEWSLETTER_URL, {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (r) {
          return r.json().catch(function () {
            return { ok: r.ok };
          });
        })
        .then(function (data) {
          if (data && data.ok) {
            card.remove();
            addBubble(
              "bot",
              "Vielen Dank. Wir haben Ihnen eine E-Mail geschickt — bitte bestätigen Sie kurz Ihre Anmeldung, dann ist Ihr **" +
                WELCOME_PCT +
                " %-Gutschein** unterwegs. (Bitte auch den Spam-Ordner prüfen.)"
            );
          } else {
            var code = data && data.error;
            if (code === "invalid_email")
              showErr("Diese E-Mail-Adresse sieht nicht gültig aus. Bitte prüfen Sie sie.");
            else
              showErr(
                "Das hat leider nicht geklappt. Bitte versuchen Sie es später erneut oder schreiben Sie an kontakt@drkalla.com."
              );
            btn.disabled = false;
            btn.textContent = label;
          }
        })
        .catch(function () {
          showErr("Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.");
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  // --- rendering -----------------------------------------------------------
  function addBubble(kind, text) {
    var wrap = el("div", "dk-msg dk-msg--" + (kind === "user" ? "user" : "bot"));
    var bubble = el("div", "dk-msg__bubble", renderText(text));
    wrap.appendChild(bubble);
    body.appendChild(wrap);
    scrollDown();
    return bubble;
  }
  function clearStatus() {
    if (statusEl) {
      statusEl.remove();
      statusEl = null;
    }
  }
  function showStatus(text) {
    clearStatus();
    statusEl = el(
      "div",
      "dk-status",
      escapeHtml(text) +
        ' <span class="dk-status__dots"><span></span><span></span><span></span></span>'
    );
    body.appendChild(statusEl);
    scrollDown();
  }
  function appendText(delta) {
    clearStatus();
    if (!currentBubble) {
      currentBubble = addBubble("bot", "");
      currentBubble._raw = "";
    }
    currentBubble._raw += delta;
    currentBubble.innerHTML = renderText(currentBubble._raw);
    scrollDown();
  }
  function renderProducts(items) {
    clearStatus();
    currentBubble = null;
    var row = el("div", "dk-products");
    items.forEach(function (p) {
      row.appendChild(productCard(p));
    });
    body.appendChild(row);
    scrollDown();
  }
  function productCard(p) {
    var card = el("div", "dk-prod");
    var media = el("div", "dk-prod__media" + (p.image ? "" : " dk-prod__media--empty"));
    if (p.image) {
      var img = el("img");
      img.src = p.image;
      img.alt = p.title || "";
      img.loading = "lazy";
      media.appendChild(img);
    } else {
      media.textContent = "✦";
    }
    card.appendChild(media);

    var bodyEl = el("div", "dk-prod__body");
    bodyEl.appendChild(el("div", "dk-prod__title", escapeHtml(p.title || "")));

    if (p.profiPriceFormatted) {
      // Pro price highlighted, normal price kept (struck) for reference.
      var profiWrap = el("div", "dk-prod__price");
      profiWrap.innerHTML =
        '<span class="dk-prod__profi">Profi ' +
        escapeHtml(p.profiPriceFormatted) +
        "</span>" +
        (p.priceFormatted ? ' <s>' + escapeHtml(p.priceFormatted) + "</s>" : "");
      bodyEl.appendChild(profiWrap);
    } else if (p.priceFormatted) {
      var price = escapeHtml(p.priceFormatted);
      if (p.compareAtFormatted) price += " <s>" + escapeHtml(p.compareAtFormatted) + "</s>";
      bodyEl.appendChild(el("div", "dk-prod__price", price));
    }

    bodyEl.appendChild(el("div", "dk-prod__spacer"));

    var actions = el("div", "dk-prod__actions");
    var addBtn = el("button", "dk-prod__add");
    if (p.multiVariant) {
      // Several variants (e.g. nuances/sizes) — don't silently add a guessed one;
      // send the customer to the product page to pick the right variant.
      addBtn.textContent = "Variante wählen";
      addBtn.addEventListener("click", function () {
        window.location.assign(p.url || "#");
      });
    } else if (p.available && p.variantId) {
      addBtn.textContent = "In den Warenkorb";
      addBtn.addEventListener("click", function () {
        addToCart(p, addBtn);
      });
    } else {
      addBtn.textContent = "Nicht verfügbar";
      addBtn.disabled = true;
    }
    actions.appendChild(addBtn);

    var link = el("a", "dk-prod__link", "Produkt ansehen");
    link.href = p.url || "#";
    link.target = "_top";
    actions.appendChild(link);

    bodyEl.appendChild(actions);
    card.appendChild(bodyEl);
    return card;
  }
  function renderChips(items) {
    var row = el("div", "dk-chips");
    items.forEach(function (it) {
      var chip = el(
        "button",
        "dk-chip" + (it.cls ? " " + it.cls : ""),
        escapeHtml(it.label)
      );
      chip.addEventListener("click", function () {
        // WhatsApp opens externally — keep the chips row so it stays reachable.
        if (it.value === "__dk_whatsapp__") {
          openWhatsApp();
          return;
        }
        row.remove();
        if (it.value === "__dk_newsletter__") {
          openNewsletter();
          return;
        }
        submitText(it.value);
      });
      row.appendChild(chip);
    });
    body.appendChild(row);
    scrollDown();
  }

  // --- add to cart ---------------------------------------------------------
  function addToCart(p, btn) {
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = "…";
    fetch(CART_ADD, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: Number(p.variantId), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart");
        return r.json();
      })
      .then(function () {
        btn.textContent = "✓ Im Warenkorb";
        btn.classList.add("dk-added");
        // Single source of truth: re-reads /cart.js → ship bar + header bubble.
        try {
          document.dispatchEvent(new CustomEvent("dk:cart-updated"));
        } catch (e) {}
        // Notify Dawn's cart-drawer / count via its pub-sub bus, if present.
        try {
          if (
            typeof publish === "function" &&
            typeof PUB_SUB_EVENTS !== "undefined" &&
            PUB_SUB_EVENTS.cartUpdate
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "dk-chat" });
          }
        } catch (e) {}
        // In the theme editor cart mutations don't persist — skip the link there.
        try {
          if (window.Shopify && window.Shopify.designMode) return;
        } catch (e) {}
        addCartLink();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
        appendSystemNote("Konnte nicht in den Warenkorb legen. Bitte direkt auf der Produktseite versuchen.");
      });
  }
  // Update the custom header's count badge to match the theme's markup:
  // #cart-icon-bubble > .cart-count-bubble > span[aria-hidden]. The badge is
  // absent entirely when the cart is empty, so we add/remove it as needed.
  function updateCartBubble(count) {
    try {
      var link = document.querySelector("#cart-icon-bubble");
      if (!link) return;
      var bubble = link.querySelector(".cart-count-bubble");
      if (!count || count <= 0) {
        if (bubble) bubble.remove();
        return;
      }
      var shown = count < 100 ? String(count) : "99+";
      if (!bubble) {
        bubble = document.createElement("span");
        bubble.className = "cart-count-bubble";
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        link.appendChild(bubble);
      }
      var inner = bubble.querySelector('span[aria-hidden="true"]') || bubble;
      inner.textContent = shown;
    } catch (e) {
      /* non-fatal — bubble just won't refresh */
    }
  }
  function addCartLink() {
    var row = el("div", "dk-chips");
    var chip = el("a", "dk-chip", "Warenkorb ansehen →");
    chip.href = CART_URL;
    chip.target = "_top";
    chip.style.textDecoration = "none";
    row.appendChild(chip);
    body.appendChild(row);
    scrollDown();
  }
  function appendSystemNote(text) {
    var note = addBubble("bot", text);
    note.style.fontStyle = "italic";
  }

  // --- send / stream -------------------------------------------------------
  function onSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    submitText(input.value);
  }
  function submitText(text) {
    text = (text || "").trim();
    if (!text || streaming) return;
    input.value = "";
    autoGrow();
    addBubble("user", text);
    messages.push({ role: "user", content: text });
    saveHistory();
    stream();
  }

  function setBusy(on) {
    streaming = on;
    if (sendBtn) sendBtn.disabled = on;
    if (input) input.disabled = on;
  }

  function stream() {
    setBusy(true);
    currentBubble = null;
    showStatus("Einen Moment");
    var assistantText = "";
    var ac = typeof AbortController !== "undefined" ? new AbortController() : null;
    currentAbort = ac;

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
      body: JSON.stringify({
        messages: messages.slice(-12),
        offerVoucher: voucherEligible(),
      }),
      signal: ac ? ac.signal : undefined,
    })
      .then(function (resp) {
        if (!resp.ok || !resp.body) throw new Error("net");
        var reader = resp.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";

        function processBlock(block) {
          var line = block.split("\n").find(function (l) {
            return l.indexOf("data:") === 0;
          });
          if (!line) return;
          var payload = line.slice(5).trim();
          if (!payload) return;
          var evt;
          try {
            evt = JSON.parse(payload);
          } catch (e) {
            return;
          }
          handleEvent(evt);
        }

        function pump() {
          return reader.read().then(function (res) {
            if (res.done) {
              // Flush the decoder and process any trailing complete frame.
              buffer += decoder.decode();
              buffer.split("\n\n").forEach(processBlock);
              finish();
              return;
            }
            buffer += decoder.decode(res.value, { stream: true });
            var parts = buffer.split("\n\n");
            buffer = parts.pop();
            parts.forEach(processBlock);
            return pump();
          });
        }

        function handleEvent(evt) {
          if (evt.type === "status") {
            if (!assistantText) showStatus(evt.text || "Einen Moment");
          } else if (evt.type === "products") {
            renderProducts(evt.items || []);
          } else if (evt.type === "text") {
            assistantText += evt.delta || "";
            appendText(evt.delta || "");
          } else if (evt.type === "error") {
            clearStatus();
            addBubble("bot", evt.text || "Es ist ein Fehler aufgetreten.");
          } else if (evt.type === "done") {
            // handled in finish()
          }
        }

        function finish() {
          clearStatus();
          var wantsVoucher = /\[\[GUTSCHEIN\]\]/.test(assistantText);
          var clean = stripMarkers(assistantText).trim();
          if (clean) {
            messages.push({ role: "assistant", content: clean });
            saveHistory();
          }
          // Agent chose to offer the voucher — render the CTA once per session.
          if (wantsVoucher && voucherEligible()) {
            markOfferShown();
            renderVoucherCta();
          }
          currentAbort = null;
          setBusy(false);
          if (input && root.classList.contains("dk-open")) input.focus();
        }

        return pump();
      })
      .catch(function (err) {
        currentAbort = null;
        // Aborted on close — silent.
        if (err && err.name === "AbortError") {
          clearStatus();
          setBusy(false);
          return;
        }
        clearStatus();
        addBubble(
          "bot",
          "Entschuldigung, die Verbindung hat nicht geklappt. Bitte versuchen Sie es erneut oder schreiben Sie an kontakt@drkalla.com."
        );
        setBusy(false);
      });
  }

  // --- init ----------------------------------------------------------------
  function init() {
    if (document.getElementById("dk-chat-launcher-ready")) return;
    build();
    var flag = el("span");
    flag.id = "dk-chat-launcher-ready";
    flag.hidden = true;
    root.appendChild(flag);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
